import { useEffect, useState } from 'react';
import { doc, getDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config.js';

export default function TV() {
  const params = new URLSearchParams(window.location.search);
  const gymId = params.get('gym');
  const [leaderboard, setLeaderboard] = useState(null);
  const [gym, setGym] = useState(null);

  useEffect(() => {
    if (!gymId) return;
    getDoc(doc(db, `gyms/${gymId}`)).then((snap) => {
      if (snap.exists()) setGym(snap.data());
    });
    return onSnapshot(doc(db, `gyms/${gymId}/leaderboards/current`), (snap) => {
      setLeaderboard(snap.exists() ? snap.data() : null);
    });
  }, [gymId]);

  if (!gymId) {
    return (
      <div style={{ minHeight: '100vh', background: '#0E0E10', color: '#F2F2F2', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Inter', sans-serif" }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 24, fontWeight: 700, marginBottom: 8 }}>TV Leaderboard</div>
          <div style={{ color: '#6E6E76' }}>Add <code style={{ background: '#1A1A1E', padding: '2px 6px', borderRadius: 4 }}>?gym=your-gym-id</code> to the URL</div>
        </div>
      </div>
    );
  }

  const topByPoints = (leaderboard?.points || []).slice(0, 10);
  const topByStreak = (leaderboard?.streaks || []).slice(0, 5);
  const topByPRs = (leaderboard?.prs || []).slice(0, 5);
  const motm = topByPoints[0];

  return (
    <div style={{ minHeight: '100vh', background: '#0E0E10', color: '#F2F2F2', fontFamily: "'Inter', sans-serif", padding: '40px 60px' }}>
      <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 40 }}>
        <div>
          <div style={{ fontSize: 48, fontWeight: 900, letterSpacing: '0.22em', textTransform: 'uppercase' }}>
            {gym?.brand?.name || 'GEARBOX'}
          </div>
          <div style={{ fontSize: 14, letterSpacing: '0.3em', textTransform: 'uppercase', color: '#6E6E76' }}>
            {gym?.brand?.tagline || 'IYKYK'}
          </div>
        </div>
        {motm && (
          <div style={{ textAlign: 'right' }}>
            <div style={{ fontSize: 12, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#6E6E76' }}>Member of the Month</div>
            <div style={{ fontSize: 28, fontWeight: 700 }}>🏆 {motm.displayName}</div>
            <div style={{ fontSize: 14, color: '#A8A8B0' }}>{motm.pointsLifetime} pts · {motm.totalWorkouts} workouts</div>
          </div>
        )}
      </header>

      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 40 }}>
        <div>
          <h2 style={{ fontSize: 18, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#6E6E76', marginBottom: 16 }}>Leaderboard</h2>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ fontSize: 12, color: '#6E6E76', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                <th style={{ textAlign: 'left', padding: '8px 0' }}>#</th>
                <th style={{ textAlign: 'left', padding: '8px 0' }}>Name</th>
                <th style={{ textAlign: 'right', padding: '8px 0' }}>Points</th>
                <th style={{ textAlign: 'right', padding: '8px 0' }}>Workouts</th>
                <th style={{ textAlign: 'right', padding: '8px 0' }}>Streak</th>
              </tr>
            </thead>
            <tbody>
              {topByPoints.map((m, i) => (
                <tr key={m.uid} style={{ borderTop: '1px solid #2A2A30', fontSize: i < 3 ? 20 : 16 }}>
                  <td style={{ padding: '12px 0', width: 40 }}>
                    {i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : `${i + 1}`}
                  </td>
                  <td style={{ padding: '12px 0', fontWeight: i < 3 ? 700 : 400 }}>{m.displayName}</td>
                  <td style={{ padding: '12px 0', textAlign: 'right', fontWeight: 600 }}>{m.pointsLifetime || 0}</td>
                  <td style={{ padding: '12px 0', textAlign: 'right', color: '#A8A8B0' }}>{m.totalWorkouts || 0}</td>
                  <td style={{ padding: '12px 0', textAlign: 'right', color: '#A8A8B0' }}>{m.streakCurrent || 0}🔥</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div>
          <h2 style={{ fontSize: 18, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#6E6E76', marginBottom: 16 }}>Top Streaks</h2>
          {topByStreak.map((m) => (
            <div key={m.uid} style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderTop: '1px solid #2A2A30' }}>
              <span>{m.displayName}</span>
              <span style={{ fontWeight: 700 }}>{m.streakCurrent || 0} 🔥</span>
            </div>
          ))}

          <h2 style={{ fontSize: 18, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#6E6E76', marginBottom: 16, marginTop: 32 }}>Top PRs</h2>
          {topByPRs.map((m) => (
            <div key={m.uid} style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', borderTop: '1px solid #2A2A30' }}>
              <span>{m.displayName}</span>
              <span style={{ color: '#5DD39E' }}>{m.prCount || 0} PRs</span>
            </div>
          ))}
        </div>
      </div>

      <div style={{ position: 'fixed', bottom: 20, right: 40, fontSize: 11, color: '#3A3A42' }}>
        Powered by TrainForge · Live updates
      </div>
    </div>
  );
}
